import { render, staticRenderFns } from "./AnalyticsOrdersTable.vue?vue&type=template&id=226f4dac&scoped=true&"
import script from "./AnalyticsOrdersTable.vue?vue&type=script&lang=js&"
export * from "./AnalyticsOrdersTable.vue?vue&type=script&lang=js&"
import style0 from "./AnalyticsOrdersTable.vue?vue&type=style&index=0&id=226f4dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226f4dac",
  null
  
)

export default component.exports